
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21.727 19.293l-3.895-3.895a.937.937 0 00-.664-.273h-.637a8.085 8.085 0 001.719-5A8.124 8.124 0 0010.125 2 8.124 8.124 0 002 10.125a8.124 8.124 0 008.125 8.125c1.887 0 3.621-.64 5-1.719v.637c0 .25.098.488.273.664l3.895 3.895a.934.934 0 001.324 0l1.106-1.106a.942.942 0 00.004-1.328zm-11.602-4.168c-2.762 0-5-2.234-5-5 0-2.762 2.234-5 5-5 2.762 0 5 2.234 5 5 0 2.762-2.234 5-5 5z","fill":"#282E3E"}})])
          )
        }
      }
    